export enum EventStageEnum {
  ACTIVE = 'active',
  FINISHING = 'finishing',
  RESULTS = 'results',
  ENDED = 'ended',
}
